import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 11h18","key":"svg-0"}],["path",{"d":"M5 11v-4a3 3 0 0 1 3 -3h8a3 3 0 0 1 3 3v4","key":"svg-1"}],["path",{"d":"M4 17a3 3 0 1 0 6 0a3 3 0 1 0 -6 0","key":"svg-2"}],["path",{"d":"M14 17a3 3 0 1 0 6 0a3 3 0 1 0 -6 0","key":"svg-3"}],["path",{"d":"M10 17h4","key":"svg-4"}]]

const IconSpy = createReactComponent('outline', 'spy', 'Spy', __iconNode);

export default IconSpy;